import type { FC } from 'react';

import { type IMessageProps, MessageTypeEnum } from './helpers';

import { ScMessageContainer } from './styled';

const Message = ({ message, withBorder, type }: IMessageProps) => {
  const MAP_TYPE_TO_ICON_CLASSNAME: Record<MessageTypeEnum, string> = {
    [MessageTypeEnum.Warning]: 'warning-icon',
    [MessageTypeEnum.Info]: 'info-icon',
    [MessageTypeEnum.Success]: 'success-icon',
  };

  const iconClassName = MAP_TYPE_TO_ICON_CLASSNAME[type];

  return (
    <ScMessageContainer type={type} withBorder={withBorder}>
      <div className={`icon ${iconClassName}`} />
      <p className="message">{message}</p>
    </ScMessageContainer>
  );
};

export const WarningMessage: FC<
  Pick<IMessageProps, 'message' | 'withBorder'>
> = (props) => <Message {...props} type={MessageTypeEnum.Warning} />;

export const InfoMessage: FC<Pick<IMessageProps, 'message' | 'withBorder'>> = (
  props
) => <Message {...props} type={MessageTypeEnum.Info} />;

export const SuccessMessage: FC<
  Pick<IMessageProps, 'message' | 'withBorder'>
> = (props) => <Message {...props} type={MessageTypeEnum.Success} />;
